import { Controller, FieldError, FieldValues, Path } from "react-hook-form";
import { CheckboxInput } from "../../../checkbox-input/CheckboxInput";
import { FormFieldWrapper } from "../../../form-field-wrapper/FormFieldWrapper";
import { CheckboxGroupWrapper, Props } from "./CheckboxField.Parts";

export const CheckboxField = <
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
>({
  control,
  errors,
  register,
  rules,
  label,
  name,
  single,
  disabled,
  fieldOptions,
  readOnly,
}: Props<FormFields, FieldName>) => {
  if (fieldOptions) {
    return (
      <FormFieldWrapper $single={single} error={errors[name] as FieldError}>
        <Controller
          name={name}
          control={control}
          rules={{ ...rules }}
          render={({ field: controllerField }) => {
            const selectedValues: string[] = controllerField.value || [];

            const handleCheckboxChange = (
              optionValue: string,
              checked: boolean,
            ) => {
              if (checked) {
                controllerField.onChange([...selectedValues, optionValue]);
              } else {
                controllerField.onChange(
                  selectedValues.filter((val: string) => val !== optionValue),
                );
              }
            };

            return (
              <CheckboxGroupWrapper>
                {fieldOptions.map((option) => (
                  <CheckboxInput
                    key={option.value}
                    checked={
                      Array.isArray(selectedValues) &&
                      selectedValues.includes(option.value)
                    }
                    disabled={option.disabled || disabled}
                    readOnly={readOnly}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      handleCheckboxChange(option.value, e.target.checked)
                    }
                  >
                    {option.label}
                  </CheckboxInput>
                ))}
              </CheckboxGroupWrapper>
            );
          }}
        />
      </FormFieldWrapper>
    );
  } else {
    return (
      <FormFieldWrapper $single={single} error={errors[name] as FieldError}>
        <CheckboxInput
          disabled={disabled}
          readOnly={readOnly}
          {...register(name, { ...rules })}
        >
          {label}
        </CheckboxInput>
      </FormFieldWrapper>
    );
  }
};
